import React from "react";
import { Icon, Grid, Header } from "semantic-ui-react";
import { injectIntl, FormattedMessage, Link } from "gatsby-plugin-intl";

import ChangelogKo from "./changelog-ko";
import ChangelogEn from "./changelog-en";
import ChangelogBetaKo from "./changelog-beta-ko";
import ChangelogBetaEn from "./changelog-beta-en";

import imageWindows from "../assets/windows.png";

const Specification = ({ intl, beta }) => {
  const changeLog = intl.locale === "ko" ? <ChangelogKo /> : <ChangelogEn />;
  const betaChangeLog =
    intl.locale === "ko" ? <ChangelogBetaKo /> : <ChangelogBetaEn />;

  return (
    <Grid columns="2" divided relaxed="very" stackable>
      <Grid.Column>
        <Header as="h3" color="grey">
          <Icon name="history" />
          <Header.Content>
            <FormattedMessage id="section_latestversion" />
          </Header.Content>
        </Header>
        {beta ? betaChangeLog : changeLog}
        <div style={{ padding: "0 2em" }}>
          {!beta && (
            <Link href="/changelog" name="changelog" to="/changelog">
              <u>
                <FormattedMessage id="section_changelog" />
              </u>
            </Link>
          )}
        </div>
      </Grid.Column>
      <Grid.Column>
        <Header as="h3" color="grey">
          <Icon name="windows" />
          <Header.Content>
            <FormattedMessage id="section_availableon" />
          </Header.Content>
        </Header>
        <div style={{ padding: "2em" }}>
          <p>
            <FormattedMessage id="text_winavailable2" />
          </p>
          <img src={imageWindows} alt="windows" style={{ marginTop: "1em" }} />
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default injectIntl(Specification);
